import { useEffect, useState } from "react";
import {
  createNewPartner,
  verifyBusinessPanDetail,
  verifyCin,
  verifyGst,
  verifyPanDetail,
} from "../../services/VerifyService/VerifyServices";
import { GetPartnerReport } from "../../services/partner/partner";
import Seo from "../../components/SeoComponent/Seo";
import Loader from "../../components/Loader/Loader";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";

const CreatePartner = () => {
  const [createPartner, setCreatePartner] = useState(2);
  const [registerType, setRegisterType] = useState(2);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState();
  const [panData, setPanData] = useState(false);
  const [panDetails, setPanDetails] = useState();
  const [isPanVerified, setIsPanVerified] = useState(false);
  const [isBusinessVerified, setIsBusinessVerified] = useState(false);
  const [businessPanData, setBusinessPanData] = useState(false);
  const [cinData, setCinData] = useState(false);
  const [gstData, setGstData] = useState(false);

  const [form, setForm] = useState({
    name: "",
    mobile: "",
    email: "",
    pan: "",
    aadhar: "",
    pin: "",
    password: "UUU@#2dhuyeji%%6490()ynU",
    referred_by: "",
    type: "INDIVIDUAL",
    company: {
      name: "",
      gst: "",
      cin: "",
      udyam: "",
      domain: "",
      pan: "",
      address: "",
    },
    company_details: {
      company_name: "",
      brand_name: "",
      support_mail_id: "",
      whatsapp_number: "",
      calling_number: "",
      partner_domain: "",
      google_captcha_key: "",
      logo: null,
    },
  });

  const [errors, setErrors] = useState({
    name: "",
    mobile: "",
    email: "",
    pan: "",
    aadhar: "",
    pin: "",
    company: {
      name: "",
      gst: "",
      cin: "",
      udyam: "",
      domain: "",
      pan: "",
    },
    company_details: {
      company_name: "",
      brand_name: "",
      support_mail_id: "",
      whatsapp_number: "",
      calling_number: "",
      partner_domain: "",
      google_captcha_key: "",
      logo: null,
    },
  });

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const isValidPan = (pan) => /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan);

  const isValidAadhar = (aadhar) => /^\d{12}$/.test(aadhar);

  const isValidGST = (gst) => /^[0-9]{2}[A-Z0-9]{13}$/.test(gst);

  const isValidMSME = (msme) => /^UDYAM-[A-Z]{2}-\d{2}-\d{7}$/.test(msme);

  const isValidCIN = (cin) =>
    /^[LU][0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/.test(cin);

  const handleChange = (e) => {
    const { name, value, files, type } = e.target;

    if (name === "mobile") {
      if (/^\d*$/.test(value) && value.length <= 10) {
        const pin = value.length >= 6 ? value.slice(-6) : "";
        setForm((prev) => ({ ...prev, mobile: value, pin: pin }));

        if (value.length === 0) {
          setErrors((prev) => ({ ...prev, mobile: "" }));
        } else if (value.length !== 10) {
          setErrors((prev) => ({
            ...prev,
            mobile: "Mobile must be 10 digits",
          }));
        } else {
          setErrors((prev) => ({ ...prev, mobile: "" }));
        }
      }
    }

    if (name === "email") {
      setForm((prev) => ({ ...prev, email: value }));

      if (value.length === 0) {
        setErrors((prev) => ({ ...prev, email: "" }));
      } else if (!isValidEmail(value)) {
        setErrors((prev) => ({
          ...prev,
          email: "Enter a valid email",
        }));
      } else {
        setErrors((prev) => ({ ...prev, email: "" }));
      }
    }

    if (name === "pan") {
      const upperValue = value.toUpperCase();

      if (upperValue.length <= 10) {
        setForm((prev) => ({ ...prev, pan: upperValue }));
        setIsPanVerified(false);
        setPanData(false);

        if (upperValue.length === 0) {
          setErrors((prev) => ({ ...prev, pan: "" }));
        } else if (upperValue.length !== 10) {
          setErrors((prev) => ({
            ...prev,
            pan: "Invalid PAN (ABCDE1234F)",
          }));
        } else if (!isValidPan(upperValue)) {
          setErrors((prev) => ({
            ...prev,
            pan: "Invalid PAN (ABCDE1234F)",
          }));
        } else {
          setErrors((prev) => ({ ...prev, pan: "" }));
        }
      }
    }

    if (name === "aadhar") {
      if (/^\d*$/.test(value) && value.length <= 12) {
        setForm((prev) => ({ ...prev, aadhar: value }));

        if (value.length === 0) {
          setErrors((prev) => ({ ...prev, aadhar: "" }));
        } else if (!isValidAadhar(value)) {
          setErrors((prev) => ({
            ...prev,
            aadhar: "Aadhar must be 12 digits",
          }));
        } else {
          setErrors((prev) => ({ ...prev, aadhar: "" }));
        }
      }
    }

    if (name === "businessPan") {
      let cleaned = value.toUpperCase().replace(/[^A-Z0-9]/g, "");

      if (cleaned.length <= 10) {
        setBusinessPanData(false);
        setForm((prev) => ({
          ...prev,
          company: {
            ...prev.company,
            pan: cleaned,
          },
        }));

        if (cleaned.length === 0) {
          setErrors((prev) => ({
            ...prev,
            company: {
              ...prev.company,
              pan: "",
            },
          }));
        } else if (cleaned.length !== 10 || !isValidPan(cleaned)) {
          setErrors((prev) => ({
            ...prev,
            company: {
              ...prev.company,
              pan: "Invalid Business PAN (ABCDE1234F)",
            },
          }));
        } else {
          setErrors((prev) => ({
            ...prev,
            company: {
              ...prev.company,
              pan: "",
            },
          }));
        }
      }
    }

    if (name === "gst") {
      let cleaned = value.toUpperCase().replace(/[^A-Z0-9]/g, "");

      if (cleaned.length <= 15) {
        setGstData(false);
        setForm((prev) => ({
          ...prev,
          company: {
            ...prev.company,
            gst: cleaned,
          },
        }));

        if (cleaned.length === 0) {
          setErrors((prev) => ({
            ...prev,
            company: {
              ...prev.company,
              gst: "",
            },
          }));
        } else if (cleaned.length !== 15) {
          setErrors((prev) => ({
            ...prev,
            company: {
              ...prev.company,
              gst: "GST must be 15 characters",
            },
          }));
        } else if (!isValidGST(cleaned)) {
          setErrors((prev) => ({
            ...prev,
            company: {
              ...prev.company,
              gst: "Invalid GST (e.g. AB27CDE1234F1Z5)",
            },
          }));
        } else {
          setErrors((prev) => ({
            ...prev,
            company: {
              ...prev.company,
              gst: "",
            },
          }));
        }
      }
    }

    if (name === "cin") {
      let cleaned = value.toUpperCase().replace(/[^A-Z0-9]/g, "");

      if (cleaned.length <= 21) {
        setCinData(false);
        setForm((prev) => ({
          ...prev,
          company: {
            ...prev.company,
            cin: cleaned,
          },
        }));

        if (cleaned.length === 0) {
          setErrors((prev) => ({
            ...prev,
            company: {
              ...prev.company,
              cin: "",
            },
          }));
        } else if (cleaned.length !== 21) {
          setErrors((prev) => ({
            ...prev,
            company: {
              ...prev.company,
              cin: "CIN must be 21 characters",
            },
          }));
        } else if (!isValidCIN(cleaned)) {
          setErrors((prev) => ({
            ...prev,
            company: {
              ...prev.company,
              cin: "Invalid CIN format (e.g. L12345MH2010PLC123456)",
            },
          }));
        } else {
          setErrors((prev) => ({
            ...prev,
            company: {
              ...prev.company,
              cin: "",
            },
          }));
        }
      }
    }

    // if (name === "msme") {
    //     let cleaned = value.toUpperCase().replace(/[^A-Z0-9]/g, "");

    //     if (cleaned.length > 5 && cleaned.length <= 7) {
    //         cleaned = cleaned.slice(0, 5) + "-" + cleaned.slice(5);
    //     } else if (cleaned.length > 7 && cleaned.length <= 9) {
    //         cleaned = cleaned.slice(0, 5) + "-" + cleaned.slice(5, 7) + "-" + cleaned.slice(7);
    //     } else if (cleaned.length > 9) {
    //         cleaned =
    //             cleaned.slice(0, 5) +
    //             "-" +
    //             cleaned.slice(5, 7) +
    //             "-" +
    //             cleaned.slice(7, 9) +
    //             "-" +
    //             cleaned.slice(9, 16);
    //     }

    //     setForm((prev) => ({ ...prev, msme: cleaned }));

    //     if (!isValidMSME(cleaned)) {
    //         setErrors((prev) => ({
    //             ...prev,
    //             msme: "Format: UDYAM-XX-00-0000000",
    //         }));
    //     } else {
    //         setErrors((prev) => ({ ...prev, msme: "" }));
    //     }
    // }

    if (
      [
        "company_name",
        "brand_name",
        "support_mail_id",
        "whatsapp_number",
        "calling_number",
        "logo",
        "partner_domain",
        "google_captcha_key",
      ].includes(name)
    ) {
      if (type === "file") {
        const file = files[0];

        if (!file) return;

        if (file) {
          const validTypes = ["image/jpeg", "image/png", "image/jpg"];

          if (!validTypes.includes(file.type)) {
            setErrors((prev) => ({
              ...prev,
              company_details: {
                ...prev.company_details,
                logo: "Only JPG, JPEG, PNG allowed",
              },
            }));
          } else {
            setForm((prev) => ({
              ...prev,
              company_details: {
                ...prev.company_details,
                logo: file,
              },
            }));

            setErrors((prev) => ({
              ...prev,
              company_details: {
                ...prev.company_details,
                logo: "",
              },
            }));
          }
        }
        return;
      }

      setForm((prev) => ({
        ...prev,
        company_details: {
          ...prev.company_details,
          [name]: value,
        },
      }));

      let errorMsg = "";

      if (name === "company_name" || name === "brand_name") {
        const trimmedValue = value.trim();

        if (trimmedValue.length > 0 && trimmedValue.length < 3) {
          errorMsg = "Must be at least 3 characters";
        }
      }

      if (name === "support_mail_id") {
        if (value.length > 0 && !isValidEmail(value)) {
          errorMsg = "Enter valid email";
        }
      }

      if (name === "whatsapp_number" || name === "calling_number") {
        const cleanedValue = value.replace(/\D/g, ""); // remove all non-digits

        const limitedValue = cleanedValue.slice(0, 10); // max 10 digits

        setForm((prev) => ({
          ...prev,
          company_details: {
            ...prev.company_details,
            [name]: limitedValue,
          },
        }));

        let errorMsg = "";
        if (limitedValue.length > 0 && limitedValue.length !== 10) {
          errorMsg = "Must be 10 digits";
        }

        setErrors((prev) => ({
          ...prev,
          company_details: {
            ...prev.company_details,
            [name]: errorMsg,
          },
        }));

        return;
      }

      setErrors((prev) => ({
        ...prev,
        company_details: {
          ...prev.company_details,
          [name]: errorMsg,
        },
      }));

      return;
    }
  };

  const handlePan = async () => {
    try {
      if (!form.pan) {
        showErrorToast("Enter valid Pan number");
        return;
      }

      setIsLoading(true);

      const response = await verifyPanDetail({ pan_number: form.pan });
      // console.log("pan_result", response?.data);
      // console.log("pan_result", response?.data?.result);

      if (response) {
        console.log(response);
      }

      if (response?.status?.code === 200) {
        const panName = response?.data?.result?.name || "";
        setIsPanVerified(true);

        if (response?.data?.result?.name) {
          setPanData(true);
          setPanDetails(response?.data);

          setForm((prev) => ({
            ...prev,
            name: panName,
          }));

          showSuccessToast(
            response?.data?.message ||
              response?.message ||
              response?.status?.message ||
              response?.data?.data?.message,
          );
        } else {
          showErrorToast(
            response?.data?.message ||
              response?.message ||
              response?.status?.message ||
              response?.data?.data?.message,
          );
        }
      } else {
        showErrorToast(
          response?.message || response.data?.message || "API failed",
        );
      }

      setIsLoading(false);
    } catch (error) {
      showErrorToast("Server error");
      console.error("Error fetching partners:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBusinessPan = async () => {
    try {
      if (!form.company.pan) {
        showErrorToast("Enter valid Pan number");
        return;
      }

      setIsLoading(true);

      const response = await verifyBusinessPanDetail({
        company_pan: form.company.pan,
      });

      if (response?.http_response_code === 200) {
        showSuccessToast(response?.message || response?.status?.message);
        // setPanData(true);
        setIsBusinessVerified(true);
        setBusinessPanData(true);

        const companyName = response?.data?.data?.full_name;

        setForm((prev) => ({
          ...prev,
          company: {
            ...prev.company,
            name: companyName,
          },
        }));
      } else {
        showErrorToast(
          response?.message || response?.data?.message || "API failed",
        );
      }

      setIsLoading(false);
    } catch (error) {
      showErrorToast("Server error");
      console.error("Error fetching partners:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGst = async () => {
    try {
      if (!form.company.gst) {
        showErrorToast("Enter valid GST number");
        return;
      }

      setIsLoading(true);

      const response = await verifyGst({ company_gst_no: form.company.gst });

      if (response?.status?.code === 200) {
        showSuccessToast(response?.message || response?.status?.message);
        // setPanData(true);
        setIsBusinessVerified(true);
        setGstData(true);
        const companyName = response?.data?.company_name;
        const companyAddress = response?.data?.address;

        setForm((prev) => ({
          ...prev,
          company: {
            ...prev.company,
            name: companyName,
            address: companyAddress,
          },
        }));
      } else {
        showErrorToast(response.data?.message || "API failed");
      }

      setIsLoading(false);
    } catch (error) {
      showErrorToast("Server error");
      console.error("Error fetching partners:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleMsme = async () => {
    showSuccessToast("NOT INTEGRATED");
  };

  const handleCin = async () => {
    try {
      if (!form.company.cin) {
        showErrorToast("Enter valid Cin number");
        return;
      }

      setIsLoading(true);

      const response = await verifyCin({ company_cin: form.company.cin });

      if (response?.status?.code === 200) {
        showSuccessToast(response?.message || response?.status?.message);
        // setPanData(true);
        setIsBusinessVerified(true);
        const companyName = response?.data?.company_name;
        const companyAddress =
          response?.data?.details?.company_info?.registered_address;

        setCinData(true);
        setForm((prev) => ({
          ...prev,
          company: {
            ...prev.company,
            name: companyName,
            address: companyAddress,
          },
        }));
      } else {
        showErrorToast(
          response?.data?.errors || response?.data?.message || "API failed",
        );
      }

      setIsLoading(false);
    } catch (error) {
      showErrorToast("Server error");
      console.error("Error fetching partners:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGetPartner = async () => {
    try {
      const { mobile } = form;

      if (!mobile || mobile.length !== 10) {
        showErrorToast("Enter valid 10 digit mobile number");
        return;
      }
      setIsLoading(true);

      const response = await GetPartnerReport({ mobile });

      if (response?.status?.code === 200) {
        setData(response?.data);
        showSuccessToast("Partner fetched successfully");
      } else {
        showErrorToast(response?.data?.message || "API failed");
      }

      setIsLoading(false);
    } catch (error) {
      showErrorToast("Server error");
      console.error("Error fetching partners:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGetPartnerByEmail = async () => {
    try {
      const { email } = form;

      if (!email) {
        showErrorToast("Enter Email");
        return;
      }
      setIsLoading(true);

      const response = await GetPartnerReport({ email });

      if (response?.status?.code === 200) {
        setData(response?.data);

        showSuccessToast("Partner fetched successfully");
      } else {
        showErrorToast(response.data?.message || "API failed");
      }

      setIsLoading(false);
    } catch (error) {
      showErrorToast("Server error");
      console.error("Error fetching partners:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreatePartner = async () => {
    try {
      // const { company, ...rest } = form;

      // const payload = form.type === "INDIVIDUAL" ? rest : { ...rest, company };

      setIsLoading(true);

      const formData = new FormData();

      formData.append("is_partner_exist", createPartner);

      // basic fields
      formData.append("name", form.name);
      formData.append("email", form.email);
      formData.append("mobile", form.mobile);
      formData.append("password", form.password);
      formData.append("pin", form.pin);
      formData.append("type", form.type);
      formData.append("pan", form.pan);
      formData.append("aadhar", form.aadhar);
      formData.append("referred_by", form.referred_by);

      // company
      if (form.type === "BUSINESS") {
        formData.append("company[name]", form.company.name);
        formData.append("company[pan]", form.company.pan);
        formData.append("company[gst]", form.company.gst);
        formData.append("company[cin]", form.company.cin);
        formData.append("company[udyam]", form.company.udyam);
        formData.append("company[domain]", form.company.domain);
        formData.append("company[address]", form.company.address);
      }

      // company_details
      formData.append(
        "company_details[company_name]",
        form.company_details.company_name,
      );
      formData.append(
        "company_details[brand_name]",
        form.company_details.brand_name,
      );
      formData.append(
        "company_details[support_mail_id]",
        form.company_details.support_mail_id,
      );
      formData.append(
        "company_details[whatsapp_number]",
        form.company_details.whatsapp_number,
      );
      formData.append(
        "company_details[calling_number]",
        form.company_details.calling_number,
      );
      formData.append(
        "company_details[partner_domain]",
        form.company_details.partner_domain,
      );
      formData.append(
        "company_details[google_captcha_key]",
        form.company_details.google_captcha_key,
      );

      // 🔥 FILE (MAIN FIX)
      if (form.company_details.logo instanceof File) {
        formData.append("company_details[logo]", form.company_details.logo);
      }

      const response = await createNewPartner(formData);

      if (response) {
        console.log(response);
      }

      if (
        response?.data?.status?.code === 200 ||
        response?.status?.code === 200
      ) {
        setData(response?.data);
        showSuccessToast(
          response?.data?.status?.message ||
            response?.data?.message ||
            response?.message ||
            response?.data?.data?.message ||
            "Partner Create successfully",
        );
      } else if (
        response?.data?.status?.code === 422 ||
        response?.status?.code === 422
      ) {
        showErrorToast(
          response?.data?.status?.message ||
            response?.data?.message ||
            response?.message ||
            response?.data?.data?.message ||
            "something went wrong",
        );

        // console.log("statussdsad", response?.data?.status?.message);

        //    const errors = response?.data?.errors || response?.errors;

        // if (errors && typeof errors === "object") {
        //   Object.keys(errors).forEach((field) => {
        //     errors[field].forEach((msg) => {
        //       showErrorToast(msg);
        //     });
        //   });
        // } else {
        //   showErrorToast(
        //     response?.data?.status?.message || "Validation failed",
        //   );
        // }
      } else {
        showErrorToast(
          response?.data?.status?.message ||
            response?.data?.message ||
            response?.message ||
            response?.data?.data?.message ||
            "API failed",
        );
      }

      // setIsLoading(false);
    } catch (error) {
      showErrorToast("Server error");
      console.error("Error fetching partners:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const partner = data?.partners?.[0];

    if (partner) {
      const mobile = partner?.mobile_number || "";
      const pin = mobile.length >= 6 ? mobile.slice(-6) : "";

      setForm((prev) => ({
        ...prev,

        mobile: mobile,
        email: partner?.email_address || "",
        referred_by: partner?.referred_by || "",
        pin: pin,
        company: {
          ...prev.company,
          domain: partner?.partner_domain || "",
        },
      }));
    }
  }, [data]);

  const isBusinessValid =
    form.type === "BUSINESS"
      ? ((form.company.pan.length === 10 &&
          !errors?.company?.pan &&
          businessPanData) ||
          (form.company.gst.length === 15 &&
            !errors?.company?.gst &&
            gstData) ||
          (form.company.cin.length === 21 &&
            !errors?.company?.cin &&
            cinData)) &&
        isBusinessVerified
      : true;

  const baseValidation =
    form.name &&
    isPanVerified &&
    form.mobile.length === 10 &&
    form.email &&
    form.pan.length === 10 &&
    form.aadhar.length === 12 &&
    !errors.name &&
    !errors.mobile &&
    !errors.email &&
    !errors.pan &&
    !errors.aadhar;

  const isCompanyValid =
    form.company_details.partner_domain &&
    form.company_details.google_captcha_key &&
    !errors.company_details.company_name &&
    !errors.company_details.brand_name &&
    !errors.company_details.support_mail_id &&
    !errors.company_details.whatsapp_number &&
    !errors.company_details.calling_number &&
    !errors.company_details.logo;

  const isFormValid = baseValidation && isBusinessValid && isCompanyValid;

  return (
    <>
      <Seo />

      {isLoading && <Loader />}
      <div className="overflow-hidden bg-gray-100 text-gray-900 font-sans">
        <div className="w-full text-center items-center">
          <div class="bg-slate-900 p-6 text-white flex justify-between items-center border-b-4 border-blue-600">
            <h1 class="text-sm md:text-xl lg:text-2xl font-black italic">
              IDSPay Partner Onboarding
            </h1>
            <div className="text-right hidden md:block">
              <span className=" md:text-xs bg-green-700 px-3 py-1 rounded-full font-bold uppercase tracking-widest">
                Secure Onboarding as per DPDP Compliant
              </span>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-0 md:gap-10 bg-gray-200">
            <button
              onClick={() => setCreatePartner(2)}
              className={`cursor-pointer rounded-md m-3 md:m-6 p-2 
                                        text-xs md:text-md lg:text-xl font-bold transition
                                    ${
                                      createPartner === 2
                                        ? "bg-blue-700 text-white"
                                        : "bg-gray-400 hover:bg-blue-600 hover:text-white text-gray-800"
                                    }`}
            >
              Create New Partner
            </button>
            <button
              onClick={() => setCreatePartner(1)}
              className={`cursor-pointer rounded-md m-3 md:m-6 p-2 
                                text-xs md:text-md lg:text-xl  font-bold transition
                                ${
                                  createPartner === 1
                                    ? "bg-blue-700 text-white"
                                    : "bg-gray-400 hover:bg-blue-600 hover:text-white text-gray-800"
                                }`}
            >
              Proceed With Existing Partner
            </button>
          </div>

          {createPartner === 2 && (
            <div className="flex justify-center w-full px-4">
              <div className="bg-gray-100 pt-6 p-1 md:p-8 w-full max-w-6xl">
                <div
                  className="grid grid-cols-1 md:grid-cols-3
                                 gap-4 md:gap-4"
                >
                  <div>
                    <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 text-start">
                      NAME<span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={form.name}
                      readOnly
                      className="col-span-4 w-full border border-gray-300 rounded-lg px-4 py-3 text-sm transition bg-white text-black font-bold cursor-not-allowed "
                    />
                  </div>

                  <div>
                    <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 text-start">
                      MOBILE NUMBER<span className="text-red-500">*</span>
                    </label>
                    <input
                      type="tel"
                      name="mobile"
                      placeholder="Enter 10 Digit mobile no"
                      value={form.mobile}
                      onChange={handleChange}
                      className="col-span-4 w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                    />
                    {errors.mobile && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.mobile}
                      </p>
                    )}
                  </div>

                  {/* Email Input */}
                  <div>
                    <label className="block text-xs  md:text-sm font-semibold text-gray-700 mb-2 text-start">
                      EMAIL ADDRESS<span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      placeholder="email@idspay.com"
                      value={form.email}
                      onChange={handleChange}
                      className="col-span-4 w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                    />

                    {errors.email && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.email}
                      </p>
                    )}
                  </div>
                </div>

                <div className="mt-4 md:mt-10 border-2 border-gray-400 rounded-xl">
                  <div className="block text-sm md:text-md pt-4 md:pt-6 font-semibold text-gray-800 mb-2 text-center">
                    REGISTRATION CATEGORY
                  </div>
                  <div className="grid grid-cols-2 gap-2 md:gap-10 justify-center items-center">
                    <button
                      onClick={() => {
                        setRegisterType(2);
                        setForm((prev) => ({
                          ...prev,
                          type: "INDIVIDUAL",
                        }));
                      }}
                      className={`cursor-pointer rounded-xl m-4 md:m-6 p-2 md:p-3 text-md md:text-xl border-2 font-bold transition
                                        ${
                                          registerType === 2
                                            ? "text-blue-600 border-blue-600 bg-blue-50"
                                            : "text-gray-400 border-gray-900 hover:text-blue-600 hover:border-blue-600"
                                        }`}
                    >
                      INDIVIDUAL
                    </button>

                    <button
                      onClick={() => {
                        setRegisterType(1);
                        setForm((prev) => ({
                          ...prev,
                          type: "BUSINESS",
                        }));
                      }}
                      className={`cursor-pointer rounded-xl m-4 md:m-6 p-2 md:p-3 text-md md:text-xl border-2 font-bold transition
                                        ${
                                          registerType === 1
                                            ? "text-blue-600 border-blue-600 bg-blue-50"
                                            : "text-gray-400 border-gray-900 hover:text-blue-600 hover:border-blue-600"
                                        }`}
                    >
                      BUSINESS
                    </button>
                  </div>
                </div>

                {registerType === 1 && (
                  <div className="mt-6 md:mt-10 border-2 pl-4 pr-4 md:pl-6 md:pr-6 bg-blue-50 border-gray-400 rounded-xl">
                    <div className="block text-sm md:text-md pt-6 pb-1 font-semibold text-gray-900 mb-2 text-start border-b-2 border-gray-400">
                      STEP 2: BUSINESS ENTITY IDENTIFICATION{" "}
                      <span className="text-red-500">(Verify Any One)</span>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                      <div className="mb-4">
                        <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 mt-2 text-start">
                          BUSINESS PAN
                        </label>
                        <div className="grid grid-cols-5 gap-2">
                          <input
                            type="text"
                            name="businessPan"
                            value={form.company.pan}
                            onChange={handleChange}
                            placeholder="ABCDE1234F"
                            className="w-full col-span-4 border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                          />
                          <button
                            onClick={handleBusinessPan}
                            className={`col-span-1 border-2 rounded-md shadow text-sm font-bold duration-300
                                                        ${
                                                          form.company.pan
                                                            .length !== 10 ||
                                                          errors.company.pan
                                                            ? "bg-gray-400 cursor-not-allowed text-white"
                                                            : "bg-gray-800 text-white hover:bg-gray-900 hover:scale-105 hover:shadow-sm"
                                                        }`}
                            disabled={
                              form.company.pan.length !== 10 ||
                              errors.company.pan
                            }
                          >
                            VERIFY
                          </button>
                        </div>
                        {businessPanData && (
                          <div className="mt-3 flex items-center justify-between bg-green-50 border border-green-300 rounded-lg px-4 py-3">
                            <div className="flex items-center gap-2">
                              <span className="flex items-center justify-center w-5 h-5 rounded-full bg-green-600 text-white text-xs">
                                ✔
                              </span>

                              <span className="text-green-700 text-sm font-semibold">
                                Business PAN Verified
                              </span>
                            </div>
                          </div>
                        )}
                        {errors.company.pan && (
                          <p className="text-red-500 text-xs mt-1">
                            {errors.company.pan}
                          </p>
                        )}
                      </div>
                      <div className="mb-4">
                        <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 md:mt-2 text-start">
                          GST NUMBER
                        </label>
                        <div className="grid grid-cols-5 gap-2">
                          <input
                            type="text"
                            name="gst"
                            value={form.company.gst}
                            onChange={handleChange}
                            maxLength={15}
                            placeholder="27ABCDE1234F1Z5"
                            className="w-full col-span-4 border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                          />
                          <button
                            onClick={handleGst}
                            className={`col-span-1 border-2 rounded-md shadow text-sm font-bold duration-300
                                                        ${
                                                          form.company.gst
                                                            .length !== 15 ||
                                                          errors.company.gst
                                                            ? "bg-gray-400 cursor-not-allowed text-white"
                                                            : "bg-gray-800 text-white hover:bg-gray-900 hover:scale-105 hover:shadow-sm"
                                                        }`}
                            disabled={
                              form.company.gst.length !== 15 ||
                              errors.company.gst
                            }
                          >
                            VERIFY
                          </button>
                        </div>
                        {gstData && (
                          <div className="mt-3 flex items-center justify-between bg-green-50 border border-green-300 rounded-lg px-4 py-3">
                            <div className="flex items-center gap-2">
                              <span className="flex items-center justify-center w-5 h-5 rounded-full bg-green-600 text-white text-xs">
                                ✔
                              </span>

                              <span className="text-green-700 text-sm font-semibold">
                                GST Verified
                              </span>
                            </div>
                          </div>
                        )}
                        {errors.company.gst && (
                          <p className="text-red-500 text-xs mt-1">
                            {errors.company.gst}
                          </p>
                        )}
                      </div>
                      <div className="mb-4">
                        <label className="block text-xs md:text-sm  font-semibold text-gray-700 mb-2 md:mt-2 text-start">
                          MSME / UDYAM NUMBER
                        </label>
                        <div className="grid grid-cols-5 gap-2">
                          <input
                            type="text"
                            name="msme"
                            // value={form.msme}
                            // onChange={handleChange}
                            placeholder="UIDAI-XX-00-0000000"
                            className="w-full col-span-4 border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                          />
                          {/* <button onClick={handleMsme}
                                                        className={`col-span-1 border-2 rounded-md shadow text-sm font-bold duration-300
                                                         ${errors.msme || form.msme.length !== 19
                                                                ? "bg-gray-400 cursor-not-allowed text-white"
                                                                : "bg-gray-800 text-white hover:bg-gray-900 hover:scale-105 hover:shadow-sm"
                                                            }`}
                                                        disabled={!!errors.msme || form.msme.length !== 19}
                                                    >

                                                        VERIFY
                                                    </button> */}
                        </div>
                        {/* {errors.msme && (
                                                    <p className="text-red-500 text-xs mt-1">{errors.msme}</p>
                                                )} */}
                      </div>
                      <div className="mb-4">
                        <label className="block text-xs md:text-sm  font-semibold text-gray-700 mb-2 md:mt-2 text-start">
                          Company CIN
                        </label>
                        <div className="grid grid-cols-5 gap-2">
                          <input
                            type="text"
                            name="cin"
                            value={form.company.cin}
                            onChange={handleChange}
                            maxLength={21}
                            placeholder="L12345MH2010PLC123456"
                            className="w-full col-span-4 border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                          />
                          <button
                            onClick={handleCin}
                            className={`col-span-1 border-2 rounded-md shadow text-sm font-bold duration-300
                                                        ${
                                                          form.company.cin
                                                            .length !== 21 ||
                                                          errors.company.cin
                                                            ? "bg-gray-400 cursor-not-allowed text-white"
                                                            : "bg-gray-800 text-white hover:bg-gray-900 hover:scale-105 hover:shadow-sm"
                                                        }`}
                            disabled={!form.company.cin || errors.company.cin}
                          >
                            VERIFY
                          </button>
                        </div>
                        {cinData && (
                          <div className="mt-3 flex items-center justify-between bg-green-50 border border-green-300 rounded-lg px-4 py-3">
                            <div className="flex items-center gap-2">
                              <span className="flex items-center justify-center w-5 h-5 rounded-full bg-green-600 text-white text-xs">
                                ✔
                              </span>

                              <span className="text-green-700 text-sm font-semibold">
                                CIN Verified
                              </span>
                            </div>
                          </div>
                        )}

                        {errors.company.cin && (
                          <p className="text-red-500 text-xs mt-1">
                            {errors.company.cin}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                <div className="mt-6 md:mt-10 border-2 pl-4 pr-4 md:pl-6 md:pr-6 bg-gray-200 border-gray-400 rounded-xl">
                  <div className="block text-sm md:text-md pt-6 pb-1 font-semibold text-gray-900 mb-2 text-start border-b-2 border-gray-400">
                    AUTHORIZED SIGNATORY KYC
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    <div className="mb-4">
                      <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 mt-2 text-start">
                        PERSONAL PAN <span className="text-red-500">*</span>
                      </label>
                      <div className="grid grid-cols-5 gap-2">
                        <input
                          type="text"
                          name="pan"
                          value={form.pan}
                          onChange={handleChange}
                          placeholder="ABCDE1234F"
                          className="w-full col-span-4 border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                        />
                        <button
                          onClick={handlePan}
                          className={`col-span-1 border-2 rounded-md shadow text-sm font-bold duration-300
                            ${
                              form.pan.length !== 10 || errors.pan
                                ? "bg-gray-400 cursor-not-allowed text-white"
                                : "bg-gray-800 text-white hover:bg-gray-900 hover:scale-105 hover:shadow-sm"
                            }`}
                          disabled={form.pan.length !== 10 || errors.pan}
                        >
                          VERIFY
                        </button>
                      </div>
                      {errors.pan && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.pan}
                        </p>
                      )}

                      {panData && (
                        <div className="mt-3 flex items-center justify-between bg-green-50 border border-green-300 rounded-lg px-4 py-3">
                          <div className="flex items-center gap-2">
                            <span className="flex items-center justify-center w-5 h-5 rounded-full bg-green-600 text-white text-xs">
                              ✔
                            </span>

                            <span className="text-green-700 text-sm font-semibold">
                              PAN Verified
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="mb-4">
                      <label className="block text-xs md:text-sm  font-semibold text-gray-700 mb-2 mt-0 md:mt-2 text-start">
                        AADHAR NUMBER <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="aadhar"
                        value={form.aadhar}
                        onChange={handleChange}
                        placeholder="12 Digit UIDAI Number"
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                      />
                      {errors.aadhar && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.aadhar}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="mt-6 md:mt-10 border-2 pl-4 pr-4 md:pl-6 md:pr-6 bg-gray-200 border-gray-400 rounded-xl">
                  <div className="block text-sm md:text-md pt-6 pb-1 font-semibold text-gray-900 mb-2 text-start border-b-2 border-gray-400">
                    COMPANY CREDENTIALS
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    <div className="mb-4">
                      <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 mt-0 md:mt-2 text-start">
                        COMPANY DOMAIN <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="partner_domain"
                        value={form.company_details.partner_domain}
                        minLength={3}
                        onChange={handleChange}
                        placeholder="Enter Company Domain"
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                      />
                    </div>

                    <div className="mb-4">
                      <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 mt-0 md:mt-2 text-start">
                        GOOGLE CAPTACH KEY{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="google_captcha_key"
                        value={form.company_details.google_captcha_key}
                        minLength={3}
                        onChange={handleChange}
                        placeholder="Enter Google Captach Key"
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                      />
                    </div>
                  </div>
                </div>

                <div className="mt-6 md:mt-10 border-2 pl-4 pr-4 md:pl-6 md:pr-6 bg-gray-200 border-gray-400 rounded-xl">
                  <div className="block text-sm md:text-md pt-6 pb-1 font-semibold text-gray-900 mb-2 text-start border-b-2 border-gray-400">
                    COMPANY DETAILS
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    <div className="mb-4">
                      <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 mt-0 md:mt-2 text-start">
                        COMPANY NAME
                      </label>
                      <input
                        type="text"
                        name="company_name"
                        value={form.company_details.company_name}
                        minLength={3}
                        onChange={handleChange}
                        placeholder="Enter Company Name"
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                      />
                      {errors.company_details.company_name && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.company_details.company_name}
                        </p>
                      )}
                    </div>

                    <div className="mb-4">
                      <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 mt-0 md:mt-2 text-start">
                        BRAND NAME
                      </label>
                      <input
                        type="text"
                        name="brand_name"
                        value={form.company_details.brand_name}
                        minLength={3}
                        onChange={handleChange}
                        placeholder="Enter Brand Name"
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                      />
                      {errors.company_details.brand_name && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.company_details.brand_name}
                        </p>
                      )}
                    </div>

                    <div className="mb-4">
                      <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 mt-0 md:mt-2 text-start">
                        SUPPORT MAIL ID
                      </label>
                      <input
                        type="email"
                        name="support_mail_id"
                        value={form.company_details.support_mail_id}
                        onChange={handleChange}
                        placeholder="Enter support mail"
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                      />
                      {errors.company_details.support_mail_id && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.company_details.support_mail_id}
                        </p>
                      )}
                    </div>

                    <div className="mb-4">
                      <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 mt-0 md:mt-2 text-start">
                        WHATSAPP NUMBER
                      </label>
                      <input
                        type="tel"
                        name="whatsapp_number"
                        value={form.company_details.whatsapp_number}
                        onChange={handleChange}
                        minLength={10}
                        placeholder="Enter whatsapp number"
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                      />
                      {errors.company_details.whatsapp_number && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.company_details.whatsapp_number}
                        </p>
                      )}
                    </div>

                    <div className="mb-4">
                      <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 mt-0 md:mt-2 text-start">
                        CALLING NUMBER
                      </label>
                      <input
                        type="tel"
                        name="calling_number"
                        value={form.company_details.calling_number}
                        minLength={10}
                        onChange={handleChange}
                        placeholder="Enter calling number"
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                      />
                      {errors.company_details.calling_number && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.company_details.calling_number}
                        </p>
                      )}
                    </div>

                    <div className="mb-4">
                      <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 mt-0 md:mt-2 text-start">
                        LOGO
                      </label>
                      <input
                        type="file"
                        name="logo"
                        accept=".jpg,.jpeg,.png"
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 cursor-pointer"
                      />
                      {errors.company_details.logo && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.company_details.logo}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <button
                  onClick={handleCreatePartner}
                  disabled={!isFormValid}
                  className={`rounded-xl m-6 px-4 py-2 text-md md:text-xl font-bold transition
                                         ${
                                           !isFormValid
                                             ? "bg-gray-400 cursor-not-allowed text-white"
                                             : "bg-blue-500 text-white hover:bg-blue-600 cursor-pointer"
                                         }`}
                >
                  SUBMIT AND CREATE
                </button>
              </div>
            </div>
          )}

          {createPartner === 1 && (
            <div className="flex justify-center w-full px-4">
              <div className="bg-gray-100 pt-6 p-1 md:p-8 w-full max-w-6xl">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-4">
                  <div>
                    <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 text-start">
                      NAME<span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={form.name}
                      readOnly
                      className="col-span-4 w-full border border-gray-300 rounded-lg px-4 py-3 text-sm transition bg-white text-black font-bold cursor-not-allowed "
                    />
                  </div>

                  {/* Mobile Input */}
                  <div>
                    <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 text-start">
                      MOBILE NUMBER<span className="text-red-500">*</span>
                    </label>
                    <div className="grid grid-cols-5 gap-2">
                      <input
                        type="tel"
                        name="mobile"
                        placeholder="10 Digit mobile"
                        value={form.mobile}
                        onChange={handleChange}
                        className="col-span-4 w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                      />
                      <button
                        onClick={handleGetPartner}
                        className={`col-span-1 border-2 rounded-md shadow text-sm font-bold duration-300
                        ${
                          form.mobile.length !== 10 ||
                          errors.mobile
                            ? "bg-gray-400 cursor-not-allowed text-white"
                            : "bg-gray-800 text-white hover:bg-gray-900 hover:scale-105 hover:shadow-sm"
                        }`}
                        disabled={form.mobile.length !== 10 || errors.mobile}
                      >
                        FETCH
                      </button>
                    </div>

                    {errors.mobile && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.mobile}
                      </p>
                    )}
                  </div>

                  {/* Email Input */}
                  <div>
                    <label className="block text-xs  md:text-sm font-semibold text-gray-700 mb-2 text-start">
                      EMAIL ADDRESS<span className="text-red-500">*</span>
                    </label>
                    <div className="grid grid-cols-5 gap-2">
                      <input
                        type="email"
                        name="email"
                        placeholder="email@idspay.com"
                        value={form.email}
                        onChange={handleChange}
                        className="col-span-4 w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                      />
                      <button
                        onClick={handleGetPartnerByEmail}
                        className={`col-span-1 border-2 rounded-md shadow text-sm font-bold duration-300
                                                ${
                                                  !form.email || errors.email
                                                    ? "bg-gray-400 cursor-not-allowed text-white"
                                                    : "bg-gray-800 text-white hover:bg-gray-900 hover:scale-105 hover:shadow-sm"
                                                }`}
                        disabled={!form.email || errors.email}
                      >
                        FETCH
                      </button>
                    </div>
                    {errors.email && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.email}
                      </p>
                    )}
                  </div>
                </div>

                {data?.partners?.length > 0 && (
                  <div className="mt-5 overflow-x-auto">
                    <table className="min-w-full border border-gray-200 rounded-lg">
                      <thead className="bg-gray-100">
                        <tr>
                          <th className="px-4 py-2 text-left text-sm">Email</th>
                          <th className="px-4 py-2 text-left text-sm">
                            Mobile
                          </th>
                          <th className="px-4 py-2 text-left text-sm">
                            Company Domain
                          </th>
                          <th className="px-4 py-2 text-left text-sm">
                            Referred By
                          </th>
                          <th className="px-4 py-2 text-left text-sm">
                            Created At
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {data?.partners?.map((item) => (
                          <tr
                            key={item.id}
                            className="border-t cursor-pointer hover:bg-gray-100"
                          >
                            <td className="px-4 py-2 text-sm">
                              {item.email_address || "N/A"}
                            </td>
                            <td className="px-4 py-2 text-sm">
                              {item.mobile_number || "N/A"}
                            </td>
                            <td className="px-4 py-2 text-sm">
                              {item.partner_domain || "N/A"}
                            </td>
                            <td className="px-4 py-2 text-sm">
                              {item.referred_by || "N/A"}
                            </td>
                            <td className="px-4 py-2 text-sm">
                              {new Date(item.created_at).toLocaleString()}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                <div className="mt-4 md:mt-10 border-2 border-gray-400 rounded-xl">
                  <div className="block text-sm md:text-md pt-4 md:pt-6 font-semibold text-gray-800 mb-2 text-center">
                    REGISTRATION CATEGORY
                  </div>
                  <div className="grid grid-cols-2 gap-2 md:gap-10 justify-center items-center">
                    <button
                      onClick={() => {
                        setRegisterType(2);
                        setForm((prev) => ({
                          ...prev,
                          type: "INDIVIDUAL",
                        }));
                      }}
                      className={`cursor-pointer rounded-xl m-4 md:m-6 p-2 md:p-3 text-md md:text-xl border-2 font-bold transition
                                        ${
                                          registerType === 2
                                            ? "text-blue-600 border-blue-600 bg-blue-50"
                                            : "text-gray-400 border-gray-900 hover:text-blue-600 hover:border-blue-600"
                                        }`}
                    >
                      INDIVIDUAL
                    </button>

                    <button
                      onClick={() => {
                        setRegisterType(1);
                        setForm((prev) => ({
                          ...prev,
                          type: "BUSINESS",
                        }));
                      }}
                      className={`cursor-pointer rounded-xl m-4 md:m-6 p-2 md:p-3 text-md md:text-xl border-2 font-bold transition
                                        ${
                                          registerType === 1
                                            ? "text-blue-600 border-blue-600 bg-blue-50"
                                            : "text-gray-400 border-gray-900 hover:text-blue-600 hover:border-blue-600"
                                        }`}
                    >
                      BUSINESS
                    </button>
                  </div>
                </div>

                {registerType === 1 && (
                  <div className="mt-6 md:mt-10 border-2 pl-4 pr-4 md:pl-6 md:pr-6 bg-blue-50 border-gray-400 rounded-xl">
                    <div className="block text-sm md:text-md pt-6 pb-1 font-semibold text-gray-900 mb-2 text-start border-b-2 border-gray-400">
                      STEP 2: BUSINESS ENTITY IDENTIFICATION{" "}
                      <span className="text-red-500">(Verify Any One)</span>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                      <div className="mb-4">
                        <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 mt-2 text-start">
                          BUSINESS PAN
                        </label>
                        <div className="grid grid-cols-5 gap-2">
                          <input
                            type="text"
                            name="businessPan"
                            value={form.company.pan}
                            onChange={handleChange}
                            placeholder="ABCDE1234F"
                            className="w-full col-span-4 border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                          />
                          <button
                            onClick={handleBusinessPan}
                            className={`col-span-1 border-2 rounded-md shadow text-sm font-bold duration-300
                                                        ${
                                                          form.company.pan
                                                            .length !== 10 ||
                                                          errors.company.pan
                                                            ? "bg-gray-400 cursor-not-allowed text-white"
                                                            : "bg-gray-800 text-white hover:bg-gray-900 hover:scale-105 hover:shadow-sm"
                                                        }`}
                            disabled={
                              form.company.pan.length !== 10 ||
                              errors.company.pan
                            }
                          >
                            VERIFY
                          </button>
                        </div>
                        {businessPanData && (
                          <div className="mt-3 flex items-center justify-between bg-green-50 border border-green-300 rounded-lg px-4 py-3">
                            <div className="flex items-center gap-2">
                              <span className="flex items-center justify-center w-5 h-5 rounded-full bg-green-600 text-white text-xs">
                                ✔
                              </span>

                              <span className="text-green-700 text-sm font-semibold">
                                PAN Verified
                              </span>
                            </div>
                          </div>
                        )}
                        {errors.company.pan && (
                          <p className="text-red-500 text-xs mt-1">
                            {errors.company.pan}
                          </p>
                        )}
                      </div>
                      <div className="mb-4">
                        <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 md:mt-2 text-start">
                          GST NUMBER
                        </label>
                        <div className="grid grid-cols-5 gap-2">
                          <input
                            type="text"
                            name="gst"
                            value={form.company.gst}
                            onChange={handleChange}
                            maxLength={15}
                            placeholder="27ABCDE1234F1Z5"
                            className="w-full col-span-4 border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                          />
                          <button
                            onClick={handleGst}
                            className={`col-span-1 border-2 rounded-md shadow text-sm font-bold duration-300
                                                        ${
                                                          form.company.gst
                                                            .length !== 15 ||
                                                          errors.company.gst
                                                            ? "bg-gray-400 cursor-not-allowed text-white"
                                                            : "bg-gray-800 text-white hover:bg-gray-900 hover:scale-105 hover:shadow-sm"
                                                        }`}
                            disabled={
                              form.company.gst.length !== 15 ||
                              errors.company.gst
                            }
                          >
                            VERIFY
                          </button>
                        </div>
                        {gstData && (
                          <div className="mt-3 flex items-center justify-between bg-green-50 border border-green-300 rounded-lg px-4 py-3">
                            <div className="flex items-center gap-2">
                              <span className="flex items-center justify-center w-5 h-5 rounded-full bg-green-600 text-white text-xs">
                                ✔
                              </span>

                              <span className="text-green-700 text-sm font-semibold">
                                GST Verified
                              </span>
                            </div>
                          </div>
                        )}
                        {errors.company.gst && (
                          <p className="text-red-500 text-xs mt-1">
                            {errors.company.gst}
                          </p>
                        )}
                      </div>
                      <div className="mb-4">
                        <label className="block text-xs md:text-sm  font-semibold text-gray-700 mb-2 md:mt-2 text-start">
                          MSME / UDYAM NUMBER
                        </label>
                        <div className="grid grid-cols-5 gap-2">
                          <input
                            type="text"
                            name="msme"
                            // value={form.msme}
                            // onChange={handleChange}
                            placeholder="UIDAI-XX-00-0000000"
                            className="w-full col-span-4 border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                          />
                          {/* <button onClick={handleMsme}
                                                        className={`col-span-1 border-2 rounded-md shadow text-sm font-bold duration-300
                                                        ${errors.msme || form.msme.length !== 19
                                                                ? "bg-gray-400 cursor-not-allowed text-white"
                                                                : "bg-gray-800 text-white hover:bg-gray-900 hover:scale-105 hover:shadow-sm"
                                                            }`}
                                                        disabled={!!errors.msme || form.msme.length !== 19}
                                                    >

                                                        VERIFY
                                                    </button> */}
                        </div>
                        {/* {errors.msme && (
                                                    <p className="text-red-500 text-xs mt-1">{errors.msme}</p>
                                                )} */}
                      </div>
                      <div className="mb-4">
                        <label className="block text-xs md:text-sm  font-semibold text-gray-700 mb-2 md:mt-2 text-start">
                          Company company.cin
                        </label>
                        <div className="grid grid-cols-5 gap-2">
                          <input
                            type="text"
                            name="cin"
                            value={form.company.cin}
                            onChange={handleChange}
                            maxLength={21}
                            placeholder="L12345MH2010PLC123456"
                            className="w-full col-span-4 border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                          />
                          <button
                            onClick={handleCin}
                            className={`col-span-1 border-2 rounded-md shadow text-sm font-bold duration-300
                                                        ${
                                                          form.company.cin
                                                            .length !== 21 ||
                                                          errors.company.cin
                                                            ? "bg-gray-400 cursor-not-allowed text-white"
                                                            : "bg-gray-800 text-white hover:bg-gray-900 hover:scale-105 hover:shadow-sm"
                                                        }`}
                            disabled={!form.company.cin || errors.company.cin}
                          >
                            VERIFY
                          </button>
                        </div>
                        {cinData && (
                          <div className="mt-3 flex items-center justify-between bg-green-50 border border-green-300 rounded-lg px-4 py-3">
                            <div className="flex items-center gap-2">
                              <span className="flex items-center justify-center w-5 h-5 rounded-full bg-green-600 text-white text-xs">
                                ✔
                              </span>

                              <span className="text-green-700 text-sm font-semibold">
                                CIN Verified
                              </span>
                            </div>
                          </div>
                        )}
                        {errors.company.cin && (
                          <p className="text-red-500 text-xs mt-1">
                            {errors.company.cin}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                <div className="mt-6 md:mt-10 border-2 pl-4 pr-4 md:pl-6 md:pr-6 bg-gray-200 border-gray-400 rounded-xl">
                  <div className="block text-sm md:text-md pt-6 pb-1 font-semibold text-gray-900 mb-2 text-start border-b-2 border-gray-400">
                    AUTHORIZED SIGNATORY KYC
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    <div className="mb-4">
                      <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 mt-2 text-start">
                        PERSONAL PAN <span className="text-red-500">*</span>
                      </label>
                      <div className="grid grid-cols-5 gap-2">
                        <input
                          type="text"
                          name="pan"
                          value={form.pan}
                          onChange={handleChange}
                          placeholder="ABCDE1234F"
                          className="w-full col-span-4 border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                        />
                        <button
                          onClick={handlePan}
                          className={`col-span-1 border-2 rounded-md shadow text-sm font-bold duration-300
                                                ${
                                                  form.pan.length !== 10 ||
                                                  errors.pan
                                                    ? "bg-gray-400 cursor-not-allowed text-white"
                                                    : "bg-gray-800 text-white hover:bg-gray-900 hover:scale-105 hover:shadow-sm"
                                                }`}
                          disabled={form.pan.length !== 10 || errors.pan}
                        >
                          VERIFY
                        </button>
                      </div>
                      {panData && (
                        <div className="mt-3 flex items-center justify-between bg-green-50 border border-green-300 rounded-lg px-4 py-3">
                          <div className="flex items-center gap-2">
                            <span className="flex items-center justify-center w-5 h-5 rounded-full bg-green-600 text-white text-xs">
                              ✔
                            </span>

                            <span className="text-green-700 text-sm font-semibold">
                              PAN Verified
                            </span>
                          </div>
                        </div>
                      )}
                      {errors.pan && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.pan}
                        </p>
                      )}
                    </div>
                    <div className="mb-4">
                      <label className="block text-xs md:text-sm  font-semibold text-gray-700 mb-2 mt-0 md:mt-2 text-start">
                        AADHAR NUMBER <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="aadhar"
                        value={form.aadhar}
                        onChange={handleChange}
                        placeholder="12 Digit UIDAI Number"
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                      />
                      {errors.aadhar && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.aadhar}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="mt-6 md:mt-10 border-2 pl-4 pr-4 md:pl-6 md:pr-6 bg-gray-200 border-gray-400 rounded-xl">
                  <div className="block text-sm md:text-md pt-6 pb-1 font-semibold text-gray-900 mb-2 text-start border-b-2 border-gray-400">
                    COMPANY CREDENTIALS
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    <div className="mb-4">
                      <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 mt-0 md:mt-2 text-start">
                        COMPANY DOMAIN <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="partner_domain"
                        value={form.company_details.partner_domain}
                        minLength={3}
                        onChange={handleChange}
                        placeholder="Enter Company Domain"
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                      />
                    </div>

                    <div className="mb-4">
                      <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 mt-0 md:mt-2 text-start">
                        GOOGLE CAPTACH KEY{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="google_captcha_key"
                        value={form.company_details.google_captcha_key}
                        minLength={3}
                        onChange={handleChange}
                        placeholder="Enter Google Captach Key"
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                      />
                    </div>
                  </div>
                </div>

                <div className="mt-6 md:mt-10 border-2 pl-4 pr-4 md:pl-6 md:pr-6 bg-gray-200 border-gray-400 rounded-xl">
                  <div className="block text-sm md:text-md pt-6 pb-1 font-semibold text-gray-900 mb-2 text-start border-b-2 border-gray-400">
                    COMPANY DETAILS
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    <div className="mb-4">
                      <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 mt-0 md:mt-2 text-start">
                        COMPANY NAME
                      </label>
                      <input
                        type="text"
                        name="company_name"
                        value={form.company_details.company_name}
                        minLength={3}
                        onChange={handleChange}
                        placeholder="Enter Company Name"
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                      />
                      {errors.company_details.company_name && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.company_details.company_name}
                        </p>
                      )}
                    </div>

                    <div className="mb-4">
                      <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 mt-0 md:mt-2 text-start">
                        BRAND NAME
                      </label>
                      <input
                        type="text"
                        name="brand_name"
                        value={form.company_details.brand_name}
                        minLength={3}
                        onChange={handleChange}
                        placeholder="Enter Brand Name"
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                      />
                      {errors.company_details.brand_name && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.company_details.brand_name}
                        </p>
                      )}
                    </div>

                    <div className="mb-4">
                      <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 mt-0 md:mt-2 text-start">
                        SUPPORT MAIL ID
                      </label>
                      <input
                        type="email"
                        name="support_mail_id"
                        value={form.company_details.support_mail_id}
                        onChange={handleChange}
                        placeholder="Enter support mail"
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                      />
                      {errors.company_details.support_mail_id && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.company_details.support_mail_id}
                        </p>
                      )}
                    </div>

                    <div className="mb-4">
                      <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 mt-0 md:mt-2 text-start">
                        WHATSAPP NUMBER
                      </label>
                      <input
                        type="tel"
                        name="whatsapp_number"
                        value={form.company_details.whatsapp_number}
                        onChange={handleChange}
                        minLength={10}
                        placeholder="Enter whatsapp number"
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                      />
                      {errors.company_details.whatsapp_number && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.company_details.whatsapp_number}
                        </p>
                      )}
                    </div>

                    <div className="mb-4">
                      <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 mt-0 md:mt-2 text-start">
                        CALLING NUMBER
                      </label>
                      <input
                        type="tel"
                        name="calling_number"
                        value={form.company_details.calling_number}
                        minLength={10}
                        onChange={handleChange}
                        placeholder="Enter calling number"
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition"
                      />
                      {errors.company_details.calling_number && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.company_details.calling_number}
                        </p>
                      )}
                    </div>

                    <div className="mb-4">
                      <label className="block text-xs md:text-sm font-semibold text-gray-700 mb-2 mt-0 md:mt-2 text-start">
                        LOGO
                      </label>
                      <input
                        type="file"
                        name="logo"
                        accept=".jpg,.jpeg,.png"
                        onChange={handleChange}
                        className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 cursor-pointer"
                      />
                      {errors.company_details.logo && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.company_details.logo}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div>
                  <button
                    onClick={handleCreatePartner}
                    disabled={!isFormValid}
                    className={`rounded-xl m-6 px-4 py-2 text-md md:text-xl font-bold transition
                                         ${
                                           !isFormValid
                                             ? "bg-gray-400 cursor-not-allowed text-white"
                                             : "bg-blue-500 text-white hover:bg-blue-600 cursor-pointer"
                                         }`}
                  >
                    SUBMIT AND CREATE
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CreatePartner;
